import type { ReactNode } from "react";

import { cn } from "./lib/cn";

export interface NavItemProps {
  /** Etiket. Daraltılmış durumda gizlenir ama erişilebilir ad olarak KALIR. */
  label: string;
  /** Aktif sayfa mı — kart: *"Aktif sayfa anlaşılırdır."* */
  active?: boolean;
  /** Daraltılmış sunum: yalnız simge/baş harf görünür. */
  collapsed?: boolean;
  icon?: ReactNode;
  onClick?: () => void;
  className?: string;
}

/**
 * Gezinme öğesi — sunum bileşeni (CLOS-96 `[057]`).
 *
 * Domain BİLMEZ: hangi sayfaların var olduğu, hangi yetkinin gerektiği ve sıra
 * `apps/web/src/lib/navigation.ts` kaydında. Bu bileşen yalnız "bir gezinme öğesi nasıl
 * görünür" sorusunu cevaplıyor (`packages/ui/CLAUDE.md` — bileşen domain bilmez).
 *
 * Bağlantıyı kendisi çizmiyor: yönlendirme `react-router` işi ve bu paket router bilmez.
 * Sayfa `onClick` veriyor ya da bileşeni kendi `<Link>`'inin içine koyuyor.
 */
export function NavItem({
  label,
  active = false,
  collapsed = false,
  icon,
  onClick,
  className,
}: NavItemProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      /**
       * `aria-current="page"` aktifliği YARDIMCI TEKNOLOJİYE de söylüyor. Yalnız renkle
       * göstermek, ekran okuyucu kullanan birine hiçbir şey söylemezdi.
       */
      aria-current={active ? "page" : undefined}
      /** Daraltılmışken metin gizli; erişilebilir ad `aria-label` ile korunuyor. */
      aria-label={collapsed ? label : undefined}
      title={collapsed ? label : undefined}
      className={cn(
        "flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left text-sm transition-colors",
        "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary",
        /**
         * Aktif hap: açık lacivert zemin + lacivert metin. Eski `bg-primary/10` saydamdı,
         * yani hapın rengi altındaki yüzeye göre değişiyordu; sidebar beyaz, drawer
         * zeminliyken aynı öğe iki farklı tonda görünüyordu.
         */
        active
          ? "bg-primary-soft font-semibold text-primary"
          : "text-fg-strong hover:bg-muted hover:text-fg-heading",
        collapsed && "justify-center px-2",
        className,
      )}
    >
      {icon ? (
        <span aria-hidden="true" className="flex shrink-0 items-center">
          {icon}
        </span>
      ) : null}
      {collapsed ? null : <span className="truncate">{label}</span>}
    </button>
  );
}
